/*
 * @Author: changcheng
 * @LastEditTime: 2023-11-06 13:23:38
 */
import { useEffect, useState } from "react";
import "./_style.scss";
import { RootState } from "@root/store";
import { useSelector } from "react-redux";
import { querSaveUserWatchTime } from "@root/common/service";
import { postLeaveAdvertisementTime } from "@root/common/utils";
export function PopAdvertisement(props: {
  banner: {
    url: string;
    imageUrl: string;
  };
  move: boolean;
}) {
  var startTime = new Date().valueOf() / 1000;
  const { xy_home_slip } = useSelector(
    (state: RootState) => state.advertisementData
  );
  var x = 0; //对象X轴位置
  var y = 0; //对象Y轴位置
  var xs = 10; //对象X轴移动速度
  var ys = 10; //对象Y轴移动速度
  var interval: any = null;
  const { banner, move } = props;
  const [show, setShow] = useState(true);
  const advertisementMove = () => {
    var advertisementImg: any = document.getElementById("advertisementImg");
    if (move && advertisementImg) {
      const animationStart = () => {
        interval = setInterval(() => {
          x += xs;
          y += ys;

          advertisementImg.style.left = x + "px";
          advertisementImg.style.top = y + "px";
          if (
            x > document.body.clientWidth - advertisementImg.offsetWidth - 20 ||
            x < 0
          ) {
            xs = -1 * xs; //速度取反
          }
          if (
            y >
              document.body.offsetHeight - advertisementImg.offsetHeight - 20 ||
            y < 0
          ) {
            ys = -1 * ys;
          }
        }, 100);
      };
      animationStart();
      // 清除计时器
      advertisementImg.onmouseover = () => {
        clearInterval(interval);
      };
      // 清除计时器
      advertisementImg.onmouseout = () => {
        animationStart();
      };
    }
  };
  useEffect(() => {
    advertisementMove();
  }, []);
  /**
   * 停止计时
   */
  const hide = () => {
    postLeaveAdvertisementTime(xy_home_slip, startTime);
  };
  return (
    <>
      {show && banner.imageUrl && (
        <div className="pop_advertisement" id="advertisementImg">
          <div
            className="close"
            onClick={() => {
              setShow(false);
              clearInterval(interval);
              hide();
            }}
          >
            关闭
          </div>
          <img
            src={banner.imageUrl}
            alt=""
            onClick={() => {
              banner.url && window.open(banner.url);
            }}
          />
        </div>
      )}
    </>
  );
}
